import { Plate, PlateMark } from '@/design-system'
import { useMediaUrl } from '@/hooks/useMediaUrl'
import { catRefName, plateCaption } from '@/utils/format'

/**
 * A plate for a cat in a collection. Resolves its own signed URL, so callers
 * pass ids and never think about storage.
 */
export function CatPlate({
  catId,
  ownerId,
  catalogNo,
  name,
  date,
  place,
  household,
  friendHousehold,
  registrantName,
  coverMediaId,
  sightingCount,
  width = 'fill',
  shape = 'portrait',
}: {
  catId: string
  ownerId?: string
  catalogNo: number
  name: string | null
  date?: string | null
  place?: string | null
  household?: boolean
  friendHousehold?: boolean
  registrantName?: string | null
  coverMediaId: string | null
  sightingCount?: number
  width?: 'rail' | 'rail-lg' | 'fill'
  shape?: 'portrait' | 'square'
}) {
  const url = useMediaUrl(coverMediaId, 'thumb')
  const to = '/gato/' + catId + (ownerId ? '?de=' + ownerId : '')

  return (
    <Plate
      to={to}
      src={url}
      name={catRefName(name, catalogNo)}
      width={width}
      shape={shape}
      caption={
        household
          ? 'En casa'
          : friendHousehold
            ? registrantName
              ? 'De ' + registrantName
              : 'De un amigo'
            : plateCaption({ catalogNo, place, date })
      }
      marks={
        household ? (
          <PlateMark icon="home" tone="accent" />
        ) : friendHousehold ? (
          <PlateMark icon="heart-filled" tone="accent" />
        ) : sightingCount && sightingCount > 1 ? (
          <PlateMark icon="paw">{sightingCount}</PlateMark>
        ) : undefined
      }
    />
  )
}
